import React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';

interface MarkdownRendererProps {
  children?: string;
  classname?: string;

  inline?: boolean;
}

const components: Components = {
  code(props) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { children, className, node, ...rest } = props;
    if (className?.includes(`vsly/json/recs`)) {
      return null;
    }

    return (
      <code className={className} {...rest}>
        {children}
      </code>
    );
  },
};

export function MarkdownRenderer({
  children,
  classname,
  inline = false,
}: MarkdownRendererProps) {
  return (
    <ReactMarkdown
      className={classname}
      components={{ ...(inline ? {} : components) }}
      linkTarget="_blank"
    >
      {children}
    </ReactMarkdown>
  );
}
